import { call, put, takeLatest, all } from "redux-saga/effects";
import { GET_QNA_LIST, ADD_UPDATE_ANSWER, PUBLISH_QUESTIONS, DISABLE_QUESTIONS, DOWNLOAD_QUESTIONS, BULK_INSERT_QA, BULK_PUBLISH_QA } from "../actionTypes/qnaActiontypes"
import { setQnaList, setQnaLoader } from "../actionCreators/qnaActionCreator";
import { getQnaList, addUpdateAnswerCall, publishQuestionsCall, disableQuestionsCall, downloadQuestionsCall, bulkInsertQACall, bulkPublishQACall } from "../services/qnaService";
import { toast } from "react-hot-toast";


function* _getQnaList(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(getQnaList, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            yield put(setQnaList(data.data))
        }
        else {
            _data.callback && _data.callback(data)
        }
    }
    catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_getQnaList: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

function* _addUpdateAnswer(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(addUpdateAnswerCall, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(null)
        }
        else {
            _data.callback && _data.callback(data)
        }
    }
    catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_addUpdateAnswer: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

function* _publishQuestions(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(publishQuestionsCall, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(null)
        }
        else {
            _data.callback && _data.callback(data)
        }
    }
    catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_publishQuestions: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

function* _disableQuestions(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(disableQuestionsCall, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(null)
        }
        else {
            _data.callback && _data.callback(data)
        }
    }
    catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_disableQuestions: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

function* _downloadQuestions(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(downloadQuestionsCall, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(null)
            toast.success(data.message)
        }
        else {
            _data.callback && _data.callback(data)
        }
    }
    catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_downloadQuestions: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

// @@ AI-COMMENT: Saga handler for bulk inserting Q&A via CSV upload
function* _bulkInsertQA(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(bulkInsertQACall, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            // @@ AI-COMMENT: Pass response data to callback so component can extract qIds for publish step
            _data.callback && _data.callback(null, data.data);
        } else {
            _data.callback && _data.callback(data, null);
            toast.error(data.message || "Insert failed.");
        }
    } catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_bulkInsertQA: exceptionError: ", err);
        toast.error("Something went wrong.");
    }
}

// @@ AI-COMMENT: Saga handler for bulk publishing Q&A by uploading a CSV of qIds
function* _bulkPublishQA(_data: any) {
    try {
        yield put(setQnaLoader(true));
        const { data } = yield call(bulkPublishQACall, _data.payload);
        yield put(setQnaLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(null, data.data);
        } else {
            _data.callback && _data.callback(data, null);
            toast.error(data.message || "Publish failed.");
        }
    } catch (err: any) {
        yield put(setQnaLoader(false));
        console.log("_bulkPublishQA: exceptionError: ", err);
        toast.error("Something went wrong.");
    }
}

export default function* qnaSaga() {
    yield all([
        takeLatest(GET_QNA_LIST, _getQnaList),
        takeLatest(ADD_UPDATE_ANSWER, _addUpdateAnswer),
        takeLatest(PUBLISH_QUESTIONS, _publishQuestions),
        takeLatest(DISABLE_QUESTIONS, _disableQuestions),
        takeLatest(DOWNLOAD_QUESTIONS, _downloadQuestions),
        takeLatest(BULK_INSERT_QA, _bulkInsertQA),
        takeLatest(BULK_PUBLISH_QA, _bulkPublishQA)
    ])
}